<p class="mb-8 text-generic">
    {{ 'BUSINESS_ADDRESS.ENTER_DETAILS' | translate }}
</p>

<!-- Form Selection Cards -->
<div *ngIf="!currentActiveForm">
    <div class="grid grid-cols-4 gap-6">
        <div *ngFor="let item of formsDetails"
            class="bg-white py-5 px-6 rounded-3xl col-span-4 [@media(min-width:480px)]:col-span-2 justify-center items-center flex-col gap-4 flex text-center">
            <div class="bg-(--bg-color) rounded-full w-10 h-10 flex justify-center items-center">
                <img [src]="item.iconPath" alt="icon" class="w-5 h-5" />
            </div>

            <p class="text-medium">{{ item.label | translate }}</p>

            <button type="button" class="click-text flex justify-center items-center gap-4"
                (click)="handleFormClick(item.key)">
                <img src="assets/icons/add-blue.svg" />
                {{ 'KEY_PERSONNEL_DETAILS.ADD_DETAILS' | translate }}
            </button>
        </div>
    </div>

    <!-- Continue Button (disabled until all forms are valid) -->
    <app-button text="{{  isIndividualOwnersCompleted() ? 'KEY_PERSONNEL_DETAILS.SUBMIT_APPLICATION' : 'KEY_PERSONNEL_DETAILS.CONTINUE' | translate }}" type="button" variant="primary" size="lg"
        extraClass="mt-8 mb-12 w-full" [disabled]="!isIndividualOwnersCompleted()" (action)="handleNextStep()"></app-button>
</div>

<!-- Active Form Section -->
<div *ngIf="currentActiveForm">
    <ng-container [ngSwitch]="currentActiveForm">
        <app-individual-owners *ngSwitchCase="formKeys.INDIVIDUAL_OWNERS" [data]="formData[formKeys.INDIVIDUAL_OWNERS]"
            (formSubmit)="handleFormSubmit(formKeys.INDIVIDUAL_OWNERS, $event)" 
            (closeCurrentForm)="closeCurrentForm()"></app-individual-owners>

        <app-corporate-owners *ngSwitchCase="formKeys.CORPORATE_OWNERS" [data]="formData[formKeys.INDIVIDUAL_OWNERS]"
            (formSubmit)="handleFormSubmit(formKeys.INDIVIDUAL_OWNERS, $event)"
            (closeCurrentForm)="closeCurrentForm()"></app-corporate-owners>

        <app-executive-management *ngSwitchCase="formKeys.EXECUTIVE_MANAGEMENT"
            [data]="formData[formKeys.EXECUTIVE_MANAGEMENT]"
            (formSubmit)="handleFormSubmit(formKeys.EXECUTIVE_MANAGEMENT, $event)"
            (closeCurrentForm)="closeCurrentForm()"></app-executive-management>

        <app-authorized-signatory *ngSwitchCase="formKeys.AUTHORIZED_SIGNATORY"
            [data]="formData[formKeys.AUTHORIZED_SIGNATORY]"
            (formSubmit)="handleFormSubmit(formKeys.AUTHORIZED_SIGNATORY, $event)"
            (closeCurrentForm)="closeCurrentForm()"></app-authorized-signatory>
    </ng-container>
</div>


<!-- Status component to show when all the forms are completed. -->
<app-status-screen-component *ngIf="showStatusScreen">
    <div class="bg-white p-6 rounded-4xl">
        <img src="assets/icons/info-timer.svg" class="mx-auto mb-8 md:w-20 md:h-20 w-14 h-14" />

        <h2 class="md:text-[32px] text-2xl mb-8 text-black font-semibold">{{ 'KEY_PERSONNEL_DETAILS.STATUS_TITLE' | translate}}</h2>
        <p class="font-medium text-base leading-6 mb-8 text-(--text-muted)">{{ 'KEY_PERSONNEL_DETAILS.STATUS_DESCRIPTION' | translate}}</p>


        <app-button text="{{ 'KEY_PERSONNEL_DETAILS.STATUS_LOGOUT' | translate }}" type="button" variant="primary" size="lg" extraClass="md:mt-10 mt-6 w-full"
            (action)="handleLogout()"></app-button>
    </div>

</app-status-screen-component>